import { useState } from 'react'
import Carousel from 'react-bootstrap/Carousel'
import { useNavigate, useParams } from 'react-router-dom'

/* Android add-bulletin tile (detail mode): two overlapping 55dp white circles
   with a thick #F2F2F2 ring — chat-bubble icon + bold green plus — and a bold
   16sp #575756 caption underneath */
export function AddBulletinTile() {
    return (
        <div className="flex min-h-[112px] flex-col items-center justify-center px-4 py-4 text-center">
            <div className="flex" dir="ltr">
                <div className="w-[55px] h-[55px] rounded-full bg-white ring-4 ring-[#F2F2F2] flex items-center justify-center">
                    <svg
                        className="w-9 h-9"
                        viewBox="0 0 37 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M26.719 6.588 11.715 6.625c-2.553.006-4.61 2.07-4.594 4.609l.058 9.194c.016 2.538 2.099 4.591 4.652 4.585l1.744-.003.03 4.672 4.669-4.684 8.564-.021c2.554-.006 4.61-2.07 4.595-4.609l-.058-9.193c-.023-2.541-2.103-4.593-4.656-4.587Z"
                            fill="#fff"
                            stroke="#74B743"
                            strokeWidth="1.7"
                        />
                        <circle cx="20.45" cy="15.87" r="1.74" fill="#74B743" />
                        <circle cx="15.85" cy="15.88" r="1.74" fill="#74B743" />
                    </svg>
                </div>
                <div className="w-[55px] h-[55px] -ml-[25px] z-10 rounded-full bg-white ring-4 ring-[#F2F2F2] flex items-center justify-center">
                    <svg
                        className="w-4 h-4"
                        viewBox="0 0 16 16"
                        fill="none"
                        stroke="#74B743"
                        strokeWidth="3"
                        strokeLinecap="round"
                    >
                        <path d="M8 1.5v13M1.5 8h13" />
                    </svg>
                </div>
            </div>
            <p className="mt-1.5 text-base font-bold text-[#575756]">
                اعلان برای اعضای صندوق ثبت کنید
            </p>
        </div>
    )
}

interface ICustomCarouselProps {
    bulletins: IBulletiens[]
    isFuckingManager: () => boolean
}
export default function CustomCarousel({
    bulletins,
    isFuckingManager,
}: ICustomCarouselProps) {
    const navigate = useNavigate()
    const { id } = useParams()
    const [activeIndex, setActiveIndex] = useState<number>(0)
    const itemsCount = bulletins.length + (isFuckingManager() ? 1 : 0)
    return (
        <div className="relative">
            <Carousel
                indicators={false}
                controls={false}
                interval={null}
                activeIndex={activeIndex}
                onSelect={(idx) => setActiveIndex(idx)}
                className="overflow-hidden rounded-[16px] bg-[#F2F2F2]"
                onClick={() =>
                    navigate('/fund/bulletin', {
                        state: {
                            bulletins,
                            isManager: isFuckingManager(),
                            moneyPool: id,
                        },
                    })
                }
            >
                {isFuckingManager() && (
                    <Carousel.Item>
                        <AddBulletinTile />
                    </Carousel.Item>
                )}
                {bulletins.map((item) => (
                    <Carousel.Item key={item.id}>
                        {/* Android: sticker 80dp on the LEFT, 3-line
                            right-aligned text, blue «show more» when clamped */}
                        <div className="flex min-h-[112px] items-start gap-2 px-4 py-4">
                            <div className="flex-1 min-w-0">
                                <p className="min-h-[63px] text-right text-sm text-black line-clamp-3">
                                    {item.text}
                                </p>
                                {item.text.length > 100 && (
                                    <p className="mt-0.5 text-right text-xs text-[#2196F3]">
                                        مشاهده متن کامل
                                    </p>
                                )}
                            </div>
                            <img
                                src={item.sticker.image}
                                className="w-20 h-20 shrink-0 object-contain"
                                alt=""
                                onError={(e) => {
                                    e.currentTarget.style.display = 'none'
                                }}
                            />
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>
            {/* Dot indicators in a gray pill, like Android (#BDBDBD pill,
                white 6dp active dot, #D4D4D4 4dp idle dots) */}
            {bulletins.length > 0 && itemsCount > 1 && (
                <div className="pointer-events-none absolute bottom-[14px] left-1/2 -translate-x-1/2 flex items-center gap-1 rounded-[16px] bg-[#BDBDBD] px-1 py-0.5">
                    {Array.from({ length: itemsCount }).map((_, i) => (
                        <span
                            key={i}
                            className={
                                i === activeIndex
                                    ? 'w-1.5 h-1.5 rounded-full bg-white'
                                    : 'w-1 h-1 rounded-full bg-[#D4D4D4]'
                            }
                        />
                    ))}
                </div>
            )}
        </div>
    )
}
